<template>
  <div class="divS" :id="`divS${id}`" @scroll="scroll($event)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: { scrollTop: Number },
  data() {
    return {
      id: new Date().getTime(),
      top: 0,
    };
  },
  watch: {
    scrollTop(e) {
      let dom = document.getElementById(`divS${this.id}`);
      dom.scrollTop = e;
    },
  },
  activated() {
    let dom = document.getElementById(`divS${this.id}`);
    dom.scrollTop = this.top;
  },
  methods: {
    scroll(ev) {
      this.top = ev.target.scrollTop;
      this.$emit("scroll", ev);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/divS.vue